module.exports = __webpack_public_path__ + "static/media/Spinner.090f8556.gif";